

import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/ListTab.vue';
import TabsNav from '@/components/tabs/TabsNavIcons.vue';

import PartnersModule from '@/store/partners';

@Component({
    components: {
        Layout,
        ListBlock,
        TabsNav,
    }
})
export default class SubscriptionsPage extends Vue {
    repository = PartnersModule;

    get tabsNav() {
        return PartnersModule.tabsNav;
    }

    get currentTab() {
        return PartnersModule.allTabs.partners.id;
    }

    toAdd() {
        this.$router.push({ name: 'partners_create' });
    }
}
